import type { ComponentProps } from 'react';
import { match } from 'ts-pattern';
import { LabelXBase } from '@/components/LabelX';
import { AvatarPerson } from '@/features/person/components/AvatarPerson';
import { cn } from '@/lib/cn';
type Props = {
  name?: string;
  /**
   * アバター画像のURL（メンバーの写真が設定されていないことを考慮してundefinedを許容する）
   */
  avatarUrl?: string;
  /**
   * ホバーしたら大きくなってほしいかどうか
   */
  hoverScale?: boolean;
} & Omit<ComponentProps<typeof LabelXBase>, 'label'>;

/**
 * 人物のアバターとラベルを表示するコンポーネント
 */
export function LabelPerson({
  avatarUrl,
  hoverScale,
  ...props
}: Props) {
  const size = match(props.size).with('Default', () => 24 as const).with('Large', () => 32 as const).with('Small', () => 16 as const).with('ExtraSmall', () => 12 as const).otherwise(() => 24 as const);
  return <LabelXBase {...props} label={props.name}>
      <AvatarPerson src={avatarUrl} name={props.name} size={size}
    // hoverScaleが指定されているか、previewCardがある場合にhoverScaleをtrueにする
    hoverScale={hoverScale ?? !!props.previewCardContent} className={cn('shrink-0 bg-neutral-muted-fill')} />
    </LabelXBase>;
}